import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ef from "../images/ef.webp";
import slide2 from "../images/slide2.gif";
import kl from "../images/kl.webp";

const Slide = () => {
  const [swiperRef, setSwiperRef] = useState(null);

  return (
    <motion.section 
      className="swiper-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: false }} 
    >
    <Swiper
        onSwiper={setSwiperRef}
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={30}
        slidesPerView={3}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: "#prevBtn",
          nextEl: "#nextBtn",
        }}
        breakpoints={{
          1440: { slidesPerView: 3 },
          1024: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
          320: { slidesPerView: 1 },
        }}
      >
        {[
          {
            img: ef,
            title: "DEAKIN UNIVERSITY INSTITUTE",
            desc: "Australia and New Zealand",
          },
          {
            img: slide2,
            title: "DEAKIN UNIVERSITY RESEARCH INSTITUTE",
            desc: "The Institute for Intelligent Systems Innovation",
          },
          {
            img: kl,
            title: "AUSTRALIAN GOVERNMENT",
            desc: "Fair Work Commission",
          },
          {
            img: ef,
            title: "DEAKIN UNIVERSITY INSTITUTE",
            desc: "Australia and New Zealand",
          },
          {
            img: slide2,
            title: "DEAKIN UNIVERSITY RESEARCH INSTITUTE",
            desc: "The Institute for Intelligent Systems Innovation",
          },
          {
            img: kl,
            title: "AUSTRALIAN GOVERNMENT",
            desc: "Fair Work Commission",
          },
        ].map((project, index) => (
          <SwiperSlide key={index}>
            <motion.div
              className="project-card text-center"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: false }} 
            >
              <img src={project.img} alt={project.title} className="project-image" />
              <div className="project-title">{project.title}</div>
              <div className="project-desc">{project.desc}</div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.section>
  );
};

export default Slide;
